<div class="form">
    <form (ngSubmit)="sendEmails()" [formGroup]="form" class="container-form">
        <div class="title">Send emails</div>

        <app-alert />

        <div class="subtitle">Please fill in the fields:</div>

        <div class="label">File name</div>
        <input autofocus class="field" formControlName="emailsFile" required type="text">

        <div class="label">Template ID</div>
        <input autofocus class="field" formControlName="templateId" required type="text">

        <div class="label">Campaign</div>
        <input autofocus class="field" formControlName="campaign" required type="text">

        <div style="font-size: 18px; margin-top: 10px">
            {{ message }}
        </div>
        <button [disabled]="!form.valid || isInProgress" class="button" type="submit">
            <span [hidden]="isInProgress">Send</span>
            <span [hidden]="!isInProgress">Sending...</span>
        </button>
    </form>
</div>
